import { registerComponent, debounce } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "slider-lite",
  class SliderLite extends WYATTElement {
    constructor() {
      super();

      this.slider = document.querySelector(this.config.navigationFor);
      this.slides = Array.from(this.slider.children);
      this.currentIndex = 0;
      this.controlButtons = this.querySelectorAll(
        "[data-slider-control-button]"
      );
    }

    connectedCallback() {
      this.setupData();
      this.addDotButtons();
      this.bindEvents();
      this.goTo(this.currentIndex, "instant");
      this.setAttribute("ready", true);
    }

    // SETUP

    setupData() {
      this.slides.forEach((slide) => {
        // Removes spacer in four-cards component on mobile
        if (window.innerWidth < 1024 && slide.innerHTML === "") {
          slide.remove();
        }
      });

      this.slides = Array.from(this.slider.children);
      this.slideCount = this.slides.length;

      this.slides.forEach((slide, index) => {
        slide.dataset.slide = index;
      });
    }

    bindEvents() {
      this.slider.addEventListener(
        "scroll",
        debounce((event) => {
          this.handleScroll(event);
        }, 300).bind(this)
      );

      this.controlButtons.forEach((button) => {
        button.addEventListener("click", this.handleControlClick.bind(this));
      });

      if (this.config.showDots) {
        this.dotButtons.forEach((button) => {
          button.addEventListener("click", this.handleDotClick.bind(this));
        });
      }
    }

    addDotButtons() {
      if (!this.config.showDots) {
        return;
      }

      const dotNavigation = document.createElement("div");
      const dotButton = this.querySelector("[data-dot-button]").content;

      this.slides.forEach((slide, index) => {
        const button = dotButton.cloneNode(true);

        button.querySelector(".slider-lite__dot").textContent = `Slide ${
          index + 1
        }`;

        button.querySelector(
          "[data-slider-dot-button]"
        ).dataset.sliderDotButton = index;

        dotNavigation.appendChild(button);
      });

      dotNavigation.classList.add("slider__navigation");
      this.appendChild(dotNavigation);

      this.dotButtons = dotNavigation.querySelectorAll(
        "[data-slider-dot-button]"
      );
    }

    // HANDLERS

    handleControlClick(event) {
      const button = event.currentTarget;
      const direction = button.dataset.sliderControlButton;
      const newIndex =
        direction === "next" ? this.currentIndex + 1 : this.currentIndex - 1;

      this.goTo(newIndex);
    }

    handleDotClick(event) {
      const button = event.currentTarget;
      const newIndex = parseInt(button.dataset.sliderDotButton, 10);

      this.goTo(newIndex);
    }

    handleScroll(event) {
      /*
        scrollLeft and offsetWidth round the actual values, therefor a buffer is needed
        to ensure the position will be slightly larger than the multiples of slideWidth
      */
      const buffer = this.slideCount;
      const position = this.slider.scrollLeft + buffer;
      const slideWidth = this.slider.querySelector("[data-slide]").offsetWidth;
      const newIndex = this.atScrollEnd()
        ? this.slideCount - 1
        : Math.floor(position / slideWidth);

      if (newIndex === this.currentIndex) {
        return;
      }

      event.preventDefault();

      this.updateState(newIndex);
    }

    // UPDATES

    updateState(newIndex) {
      this.updateCurrentSlide(newIndex);
      this.updateDotButtons(newIndex);
      this.updateControlButtons();
    }

    updateCurrentSlide(newIndex) {
      this.slides[this.currentIndex].setAttribute("active", false);
      this.currentIndex = newIndex;
      this.slides[this.currentIndex].setAttribute("active", true);
    }

    updateDotButtons(newIndex) {
      if (!this.config.showDots) {
        return;
      }
      const currentButton = this.querySelector(
        `[data-slider-dot-button][active="true"]`
      );
      const newButton = this.querySelector(
        `[data-slider-dot-button="${newIndex}"]`
      );

      currentButton?.setAttribute("active", false);
      newButton.setAttribute("active", true);
    }

    updateControlButtons() {
      if (!this.config.showControls) {
        return;
      }

      this.controlButtons.forEach((button) => {
        const direction = button.dataset.sliderControlButton;
        const onFirstSlide = this.currentIndex === 0;
        const onLastSlide = this.currentIndex + 1 === this.slideCount;

        if (direction === "previous" && onFirstSlide) {
          button.disabled = true;
        } else if (direction === "next" && onLastSlide) {
          button.disabled = true;
        } else {
          button.disabled = false;
        }
      });
    }

    atScrollEnd() {
      return (
        Math.ceil(this.slider.scrollLeft) +
          Math.ceil(this.slider.offsetWidth) >=
        this.slider.scrollWidth
      );
    }

    goTo(newIndex, behavior = "smooth") {
      const newSlide = this.slider.querySelector(`[data-slide="${newIndex}"]`);
      const width = newSlide.offsetWidth;
      const slideDifference = newIndex - this.currentIndex;

      this.slider.scrollBy({
        top: 0,
        left: width * slideDifference,
        behavior,
      });

      setTimeout(() => {
        this.updateState(newIndex);
      }, 100);
    }
  }
);
